import * as types from "../types";
import util from "../../utils/util";
// 通用配置
const state = {
  bannerList: [],
  navList: [{
      id: 1,
      link: "/comReporting", //
      show: true,
      text: "企业报表",
      url: "icon_statement.png"
    },
    {
      id: 1,
      link: "/bill", ///
      show: true,
      text: "账单",
      url: "icon_bill.png"
    },
    {
      id: 1,
      link: "/meetingRoom", //
      show: true,
      text: "会议预订",
      url: "icon_meeting.png"
    },
    {
      id: 1,
      link: "/fanke", //
      show: true,
      text: "访客预约",
      url: "icon_visitor.png"
    },
    {
      id: 1,
      link: "/wuyeRepair",
      show: true,
      text: "物业报修",
      url: "icon_repairs.png"
    },
    {
      id: 1,
      link: "/approvalList",
      show: true,
      text: "审批",
      url: "icon_audit.png"
    },
    {
      id: 1,
      link: "/revenueIndex",
      show: true,
      text: "营收填报",
      url: "icon_renenue.png"
    },
    {
      id: 1,
      link: "/emptyShopList", //
      show: true,
      text: "空铺招租",
      url: "icon_store.png"
    },
    {
      id: 1,
      link: "/robot", //
      show: true,
      text: "机器人",
      url: "icon_robot.png"
    }
  ],
  indexCenter: [],
  indexNavList: [],
  iconStyle: 0,
  noticeList: [],
  activityList: [],
  meetingRoomList: [],
  emptyShopList: [],
  companyWallList: [],
  dataList: [],
  shopsList: []
};
const actions = {
  getShopsList({
    commit
  }, res) {
    commit(types.GET_SHOPSLIST, res);
  },
  getBanerList({
    commit
  }, res) {
    commit(types.GET_BANNERLIST, res);
  },
  getActivityList({
    commit
  }, res) {
    commit(types.GET_ACTIVITYLIST, res);
  },
   getMeetingRoomList({
    commit
  }, res) {
    commit(types.GET_MEETINROOmLIST, res);
  },

  
  getEmptyShopList({
    commit
  }, res) {
    commit(types.GET_EMPTYSHOPLIST, res);
  },
  getCompanyWallList({
    commit
  }, res) {
    commit(types.GET_COMPANYWALLLIST, res);
  },
  getNoticeList({
    commit
  }, res) {
    commit(types.GET_NOTICELIST, res);
  },
  getIndexStyle({
    commit
  }, res) {
    commit(types.GET_INDEXSTYLE, res);
  }
};

const mutations = {
  [types.GET_BANNERLIST](state, val) {
    state.bannerList = val;
  },
  [types.GET_SHOPSLIST](state, val) {
    state.shopsList = val;
  },
  [types.GET_ACTIVITYLIST](state, val) {
    state.activityList = val;
  },
  [types.GET_MEETINROOmLIST](state, val) {
    state.meetingRoomList = val;
  },

  
  [types.GET_EMPTYSHOPLIST](state, val) {
    state.emptyShopList = val;
  },
  [types.GET_COMPANYWALLLIST](state, val) {
    state.companyWallList = val;
  },
  [types.GET_NOTICELIST](state, val) {
    state.noticeList = val;
  },
  [types.GET_INDEXSTYLE](state, val) {
    state.indexCenter = val.indexCenter;
    state.navList = val.menusList.filter(item => item.show) || []; // 全部tab图标
    let newA = val.menusList.filter(item => item.show)
    if (val.indexList && val.indexList.length > 0) { //&& val.iconStyle!== 4
      state.indexNavList = val.indexList.concat([{
        link: '',
        show: true,
        text: '全部',
        url: "icon_more.png"
      }]);
    } else {
      if (newA.length >= 10) {
        newA = newA.filter((item, index) => {
          return index < 9
        })
        newA.push({
          id: 1,
          link: "", //
          show: true,
          text: "全部",
          url: "icon_more.png"
        })
      }
      state.indexNavList = newA;
    }
    if (val.iconStyle || val.iconStyle === 0) {
      state.iconStyle = val.iconStyle; // 显示图标样式
    }
    if (val.dataList && val.dataList.length > 0) {
      state.dataList = val.dataList.sort(util.compare("sortOrder"));
    }
  }
};

export default {
  // namespaced: true,
  state,
  actions,
  mutations
};